import React, { useEffect, useState } from 'react';
import Project from './Project';

const Projects = () => {
  const [projects, setProjects] = useState([])
  useEffect(() => {
    fetch('projects.json')
      .then(res => res.json())
      .then(data => setProjects(data))
  }, [])
  return (
    <section className='w-4/5 mx-auto my-10' id='projects'>
      <h1 className='text-5xl font-bold text-center'>Recent Projects</h1>
      <div className='grid grid-cols-1 lg:grid-cols-2 gap-10'>
        {projects?.slice(0, 5).map((project, index) => <Project project={project} key={project.id}></Project>)}
      </div>
    </section>
  );
};

export default Projects;